import { Trans, useTranslation } from "react-i18next";

import BidItemLabel from "@krea/shared/design-system/BidItemLabel";
import { Text } from "@krea/shared/design-system/Text";
import { useFormatCurrency } from "@krea/shared/hooks/useFormatCurrency";

import { foretagarnaMemberCompensation } from "../utils";

interface IForetagarnaResultBlockProps {
  /** Whether the Företagarna member-benefit content applies (UTM + an estimate exists). */
  show: boolean;
  /** Amount the benefit is calculated from — requested amount for edge cases, estimate otherwise. */
  amount?: number;
  locale: string;
  currency: string;
}

/** Företagarna member-benefit block shown below the result card for that partner. */
export const ForetagarnaResultBlock = ({
  show,
  amount,
  locale,
  currency,
}: IForetagarnaResultBlockProps) => {
  const { t } = useTranslation("loanWidget");
  const [formattedCurrencyValue] = useFormatCurrency(locale, { currency });

  if (!show || !amount) {
    return null;
  }

  return (
    <div className="mb-5">
      <div className="flex mb-[-28px]">
        <BidItemLabel
          text={t("foretagarnaContent.title")}
          accentColor="primary"
        />
      </div>
      <Text className="text-base border border-solid border-primary px-5 pb-3 pt-8 rounded-xl bg-white mb-5">
        <Trans
          ns="loanWidget"
          i18nKey="foretagarnaContent.resultMemberBenefitText"
          values={{
            compensation: formattedCurrencyValue(
              foretagarnaMemberCompensation(amount),
            ),
            amount: formattedCurrencyValue(amount),
          }}
          components={{
            compensation: <span className="font-semibold" />,
            amount: <span className="font-semibold" />,
          }}
        />
      </Text>
    </div>
  );
};
